import { useStore } from '@stores';
import { useEffect } from 'react';

export const useCustomer = (id: number | string | undefined) => {
  const { customerStore } = useStore();
  const { customer, loading } = customerStore;

  useEffect(() => {
    id && customerStore.get({ id });

    return () => {
      customerStore.clearCustomer();
    };
  }, [customerStore, id]);

  return { customer, loading };
};
